"use client";

import React, { useState } from "react";

interface PressItem {
  categoryId: number;
  id: number;
  logo: string;
  publishedDate: string;
  publishedText: string;
  publishedUrl: string;
  smallOverview: string;
  title: string;
}

export default function PressList({ items }: { items: PressItem[] }) {
  // Initialize with 0 to make the first item blue by default
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div className="w-full">
      <div className="flex flex-col gap-[44px]">
        {items?.map((item, idx) => {
          const isActive = activeIndex === idx;
          return (
            <div
              key={idx}
              className="flex flex-col gap-6 cursor-pointer"
              onClick={() => setActiveIndex(idx)}
            >
              <div className="flex lg:flex-row flex-col gap-[10px] lg:items-center lg:gap-[54px]">
                {/* Date pill */}
                <div className="w-[200px] flex lg:justify-center">
                  <div
                    className={`rounded-[48px] border border-[#ecf0f6] px-5 py-[11px] transition-colors duration-300 ${
                      isActive
                        ? "bg-[#eef4ff] border-transparent"
                        : "bg-transparent"
                    }`}
                  >
                    <span
                      className={`text-[clamp(0.9375rem,0.6881rem+0.5196vw,1.5rem)] font-semibold ${
                        isActive ? "text-[#2563eb]" : "text-[#00040b]"
                      }`}
                    >
                      {item?.publishedDate}
                    </span>
                  </div>
                </div>

                {/* Divider */}
                <div className="w-px lg:h-[92px] bg-[#ecf0f6] hidden md:block" />

                {/* Content */}
                <div className="flex-1">
                  <a
                    href={item?.publishedUrl}
                    className={`text-[clamp(1.25rem,0.7512rem+1.0393vw,2.375rem)] leading-[120%] clash-font font-medium transition-colors duration-300 ${
                      isActive ? "text-[#2563eb]" : "text-[#00040b]"
                    }`}
                  >
                    {item.title}
                  </a>
                  {item.smallOverview && (
                    <p className="mt-[15px] text-[#636364] text-[18px] leading-[140%]">
                      {item.smallOverview}
                    </p>
                  )}
                </div>
              </div>

              {/* Row separator */}
              <div className="w-full h-px bg-[#ecf0f6]" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
